import React from 'react';
import PropTypes from 'prop-types';

const DIRECTION_MAP = {
  down: 'to bottom',
  up: 'to top',
  left: 'to left',
  right: 'to right'
};

export function Fade({ className, fadeDirection = 'down', fadeMidpoint = 50, style }) {
  const direction = DIRECTION_MAP[fadeDirection] || 'to bottom';

  // Midpoint controls where the transition happens (0-100)
  const transitionStart = Math.max(0, fadeMidpoint - 25);
  const transitionEnd = Math.min(100, fadeMidpoint + 25);

  return (
    <div
      className={ className }
      style={{
        width: '100%',
        height: '100%',
        background: `linear-gradient(${direction}, transparent 0%, transparent ${transitionStart}%, currentColor ${transitionEnd}%, currentColor 100%)`,
        ...style
      }}
    />
  );
}

Fade.propTypes = {
  className: PropTypes.string,
  fadeDirection: PropTypes.oneOf(['down', 'up', 'left', 'right']),
  fadeMidpoint: PropTypes.number
};
